import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import {Observable} from 'rxjs';

@Injectable()
export class OptionsInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const optionsReq = req.clone({
            withCredentials: true,
        });

        return next.handle(optionsReq);
    }
}
